import { AdminService } from './../../services/admin.service';
import { AppStateProvider } from './../../services/app-state.provider';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from 'src/app/config/app.constant';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  standalone: false,
  selector: 'app-members-listing',
  templateUrl: './members-listing.component.html',
  styleUrls: ['./members-listing.component.scss'],
})
export class MembersListingComponent implements OnInit {
  @ViewChild('emailmessage', { static: false }) content: ElementRef;
  page = 1;
  meetingNav: { index: string; name: string; link: string }[];
  selectAll: boolean;
  highlight: boolean;
  emailList;
  show: boolean;
  collection = [];
  closeResult: string;
  public isVisible: boolean = false;
  showLoader = false;
  multiSelecttenant: any = [];
  selectedId: any;
  selectedCompanyName: any;
  selectedTenantName: any;
  pageSize: number = 10;
  member: any;
  acronym: any;
  companyList: any = [];
  searchDept: string = '';
  val: any;
  text: string;
  membersTempNew: any;
  membersTempNewStatus: any;
  selectedMembers: any = [];
  open(content) {
    this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
        windowClass: 'custom-class',
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  membersList = [
    {
      index: '0',
      name: 'Rakesh Jha',
      role: 'Analyst',
      contact: '+91 9561088278',
      location: 'SS 03',
      company: 'Robust Technologies Pvt Ltd.',
      selected: false,
      emailid: 'abc@cap.com',
    },
    {
      index: '1',
      name: 'Rakesh Jha1',
      role: 'Analyst',
      contact: '+91 9561088278',
      location: 'SS 03',
      company: 'Robust Technologies Pvt Ltd.',
      selected: false,
      emailid: 'def@cap.com',
    },
    {
      index: '2',
      name: 'Rakesh Jha2',
      role: 'Analyst',
      contact: '+91 9561088278',
      location: 'SS 03',
      company: 'Robust Technologies Pvt Ltd.',
      selected: false,
      emailid: 'ghi@cap.com',
    },
    {
      index: '3',
      name: 'Rakesh Jha3',
      role: 'Analyst',
      contact: '+91 9561088278',
      location: 'SS 03',
      company: 'Robust Technologies Pvt Ltd.',
      selected: false,
      emailid: 'jkl@cap.com',
    },
    {
      index: '4',
      name: 'Rakesh Jha4',
      role: 'Analyst',
      contact: '+91 9561088278',
      location: 'SS 03',
      company: 'Robust Technologies Pvt Ltd.',
      selected: false,
      emailid: 'mno@cap.com',
    },
    {
      index: '5',
      name: 'Rakesh Jha5',
      role: 'Analyst',
      contact: '+91 9561088278',
      location: 'SS 03',
      company: 'Robust Technologies Pvt Ltd.',
      selected: false,
      emailid: 'pqr@cap.com',
    },
    {
      index: '6',
      name: 'Rakesh Jha6',
      role: 'Analyst',
      contact: '+91 9561088278',
      location: 'SS 03',
      company: 'Robust Technologies Pvt Ltd.',
      selected: false,
      emailid: 'stv@cap.com',
    },
    {
      index: '6',
      name: 'Rakesh Jha6',
      role: 'Analyst',
      contact: '+91 9561088278',
      location: 'SS 03',
      company: 'Robust Technologies Pvt Ltd.',
      selected: false,
      emailid: 'stv@cap.com',
    },
  ];
  totalCount;
  displayCount;
  selectedCount = 0;
  bulkEmail: boolean;
  emailIdlist: any;
  emailShow: boolean;
  url: string;
  token: any;
  members: any;
  membersDeepCopy: any;
  deptInfo: any;
  // officeToken: any;
  // access_token: any;
  searchText: string = '';
  tenantList: any;
  selectedIndex: any;
  org;
  internalToken = localStorage.getItem('token')
  constructor(
    private router: Router,
    private apiService: ApiService,
    private commonService: CommonService,
    private modalService: NgbModal,
    private appStateSrv: AppStateProvider,
    private adminService: AdminService,
  ) {
    for (let i = 1; i <= 100; i++) {
      this.collection.push(`item ${i}`);
    }
  }

  ngOnInit(): void {
    this.meetingNav = [
      {
        index: '2',
        name: 'Members',
        link: 'members/members-list',
      },
    ];

    const route = {
      index: '2',
      name: 'Members',
      link: 'members/members-list',
    };
    this.appStateSrv.setSideNavState(route);

    this.showLoader = true;
    this.getApiauthorizationToken();
    localStorage.removeItem(AppConstant.localStorage.emailList);
    this.getCompaniesList()
  }
  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }
  getApiauthorizationToken() {
    //this.commonService.getApiauthorizationToken().subscribe((res) => {
    this.token =
      'Bearer' + ' ' + localStorage.getItem(AppConstant.localStorage.token);
    if (this.token != null) {
      this.getDepartmentDetails();
      this.getOrganization();
      // this.getauthorizationToken();
      this.getMembers();
    }
    //});
  }
  // getauthorizationToken() {
  //   this.commonService
  //     .getauthorizationToken(
  //       'bearer ' + localStorage.getItem(AppConstant.localStorage.token)
  //     )
  //     .subscribe((res) => {
  //       this.access_token = res.access_token;
  //       this.officeToken = res.access_token;
  //       if (this.officeToken != null) {
  //         this.getMembers();
  //       }
  //     });
  // }
  getMembers() {
    this.url = APIs.getOfficeMembers;
    const header = {
      Authorization: this.token,
    };
    const paramObj = {
      // Authorization: this.officeToken,
      Authorization: this.internalToken
    };
    this.apiService.get(this.url, paramObj, header).subscribe(
      (response: any) => {
        this.getEmployeesList();
        // this.members=response;
        // let len =this.members.list.length;
      },
      (err) => console.log('error', err)
    );
  }

  getCompaniesList() {
    this.adminService.getCompaniesList().subscribe(response => {
      console.log('company list response ', response);
      if (response.length > 0) {
        this.companyList = response;
        const allOpt = {
          id: null,
          companyName: "All"
        }
        this.companyList.unshift(allOpt);
        this.selectedTenantName = this.companyList[0].companyName
      }
    })
  }
  getDepartmentDetails() {
    this.url = APIs.getDepartmentList;
    const header = {
      Authorization: this.token,
    };

    this.apiService.get(this.url, '', header).subscribe(
      (response: any) => {
        this.deptInfo = response;

        // this.members.list.departmentname=this.deptInfo.data.department
      },
      (err) => console.log('error', err)
    );
  }

  getEmployeesList() {
    let locationId = localStorage.getItem("locationId") ?? 1;
    this.url = APIs.getEmployeeList;
    const header = {
      Authorization: this.token,
    };
    const paramobj = {
      // TenantId:localStorage.getItem(AppConstant.localStorage.tenantId)
    };
    this.apiService.get(this.url + "?searchText=" + (this.searchText ? this.searchText : "") + '&locationId=' + locationId, paramobj, header).subscribe(
      (response: any) => {
        this.members = response;
        this.membersTempNew = response.list;
        this.membersTempNewStatus = response.list;
        this.showLoader = false;
        this.membersDeepCopy = JSON.parse(JSON.stringify(response));
        this.totalCount = this.members.list.length;
        this.displayCount = Math.ceil(this.totalCount / this.pageSize);
        this.members.list.forEach((element, index) => {
          if (element.departmentId != null) {
            let data = this.deptInfo.list.filter(
              (item) => item.id === element.departmentId
            );
            // element.department=this.deptInfo.data.department;
            this.members.list[index].department = data[0]?.department;
          }
        });
        //sorting alphabetical order
        this.members.list.sort(function (a, b) {
          if (a.userName.toLowerCase() < b.userName.toLowerCase()) { return -1; }
          if (a.userName.toLowerCase() > b.userName.toLowerCase()) { return 1; }
          return 0;
        })
        this.handlePageChange(1)
      },
      (err) => console.log('error', err)
    );
  }

  searchByText(event: any) {
    this.membersTempNew = this.members.list.filter((item: { userName: any }) => {
      return item.userName.toLowerCase().includes(event.toLowerCase());
    });
    if (this.val == 'active' || this.val == 'inactive') {
      this.membersTempNew = this.membersTempNewStatus.filter((item: { userName: any }) => {
        return item.userName.toLowerCase().includes(event.toLowerCase());
      });
    }
    this.totalCount = this.membersTempNew?.length;
    this.displayCount = Math.ceil(this.totalCount / this.pageSize);
    if (event == '') {
      this.membersTempNew = this.members.list;
      this.totalCount = this.membersTempNew.length;
      if (this.val == 'inactive') {
        this.displayType('inactive');
      }
      if (this.val == 'active') {
        this.displayType('active');
      }
    }
  }

  displayType(event: any) {
    this.searchText = '';
    this.val = event;
    if (this.val == 'active') {
      this.text = "Active";
      this.membersTempNew = this.membersTempNewStatus = [...this.members.list].filter((data) => {
        return data.t0200OrgEmployees[0].isActive == true;
      });
    }
    if (this.val == 'inactive') {
      this.text = "Inactive";
      this.membersTempNew = this.membersTempNewStatus = [...this.members.list].filter((data) => {
        return data.t0200OrgEmployees[0].isActive == false;
      });
    }
    if (this.val == 'all') {
      this.text = "";
      this.membersTempNew = [...this.members.list];
    }
    this.totalCount = this.membersTempNew.length;
    this.displayCount = Math.ceil(this.totalCount / this.pageSize);
    this.page = 1;
  }

  getOrganization() {
    let locationId = localStorage.getItem("locationId") ?? 1;
    this.url = APIs.getOrganization + '?locationId=' + locationId;
    const header = {
      Authorization: this.token,
    };

    this.apiService.get(this.url, '', header).subscribe(
      (response: any) => {
        this.tenantList = response;
      },
      (err) => console.log('error', err)
    );
  }
  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }

  // selectEmailid(item) {
  //   this.selectedIndex = item.id
  //   this.org = item.companyName;
  //   console.log('item: ', item);
  //   this.members.list = this.membersDeepCopy.list.filter((data) => data.t0200OrgEmployees[0].tenant.companyName === this.org);
  //   console.log('this.members: ', this.members.list);
  //   // this.highlight=!this.highlight;
  // }

  selectEmailid(item) {
    console.log(item);
    this.selectedTenantName = item.companyName;
    if (item.id !== null) {
      if (this.multiSelecttenant.includes(item.id)) {
        this.multiSelecttenant.splice(this.multiSelecttenant.indexOf(item.id), 1);
      } else {
        this.members.list = this.membersDeepCopy.list;
        this.multiSelecttenant.push(item.id);
      }
    }
    else {
      this.multiSelecttenant = [];
    }


    console.log('multiSelecttenant', this.multiSelecttenant);
    // console.log(this.membersDeepCopy);

    if (this.multiSelecttenant.length != 0) {
      if (this.multiSelecttenant.includes('all')) {
        console.log("YES");
        this.members.list = this.membersDeepCopy.list;
      }
      console.log("NOT");
      //   this.members.list = [];
      //   this.multiSelecttenant.forEach((id) => {
      //     this.members.list.push(this.membersDeepCopy.list[id].t0200OrgEmployees);
      //     console.log(this.members.list);
      //     this.selectedTenantName = this.members.list.companyName;
      //   });
      // }

      // this.membersTempNew = this.member.list.filter((data) => {
      //   if (this.multiSelecttenant.includes(data.t0200OrgEmployees[0].tenant.id))
      //     return data
      // });
      this.membersTempNew = this.members.list.filter((item) => {
        return this.multiSelecttenant.includes(item.t0200OrgEmployees[0].tenant.id);
      });
    } else {
      this.membersTempNew = this.membersDeepCopy.list;
    }
    this.totalCount = this.membersTempNew.length;
    this.displayCount = Math.ceil(this.totalCount / this.pageSize);
    this.members.list = this.membersTempNew;

    console.log(this.membersTempNew);

    if (this.multiSelecttenant.length >= 1)
      this.selectedTenantName = this.companyList.filter(company => company.id === this.multiSelecttenant[0])[0].companyName;
    else
      this.selectedTenantName = this.companyList[0].companyName
  }


  toggleSelectAllSelection(show) {
    this.selectAll = !this.selectAll;
    if (this.selectAll) {
      this.membersTempNew.forEach((item) => { item.selected = true; this.selectedMembers.push(item.userId) });
      this.selectedCount = this.membersTempNew.filter(
        (item) => item.selected === true
      ).length;
      this.emailIdlist = this.membersTempNew.filter(
        (item) => item.selected === true
      );
      console.log(this.emailIdlist)
      // localStorage.setItem(
      //   AppConstant.localStorage.emailList,
      //   JSON.stringify(this.emailIdlist)
      // );
      // return;

    } else {
      this.selectedMembers = [];
      this.membersTempNew.forEach((item) => (item.selected = false));
      this.emailIdlist = this.membersTempNew.filter(
        (item) => item.selected === true
      );
      this.selectedCount = this.membersTempNew.filter(
        (item) => item.selected === true
      ).length;

      // localStorage.setItem(
      //   AppConstant.localStorage.emailList,
      //   JSON.stringify(this.emailIdlist)
      // );

    }

    console.log('selectedMembers', this.selectedMembers);

  }

  emailBulkClick() {
    this.emailIdlist;
    console.log(this.emailIdlist, "bulk email")
    this.emailShow = true;
    // this.adminService.email = this.emailIdlist
    let emails = []
    this.emailIdlist.forEach(email => {
      emails.push(email.emailId);
    })
    console.log('all emails ', emails);
    // localStorage.setItem(AppConstant.localStorage.emailList, JSON.stringify(emails).replace("[", '').replace("]", ''))
    this.adminService.setEmailList(emails);
    this.router.navigate(['members/members-list/email']);
  }
  toggleBulkEmail() {
    this.bulkEmail = !this.bulkEmail;
    if (!this.bulkEmail) {
      this.selectAll = true;
      this.toggleSelectAllSelection(this.selectAll);
    }
  }

  changeState(eg, module) {
    let data = eg;
    let index = this.members.list.indexOf(data);
    data.selected = !data.selected;
    this.members.list[index] = data;

    if (this.selectedMembers.indexOf(data.userId) == -1)
      this.selectedMembers.push(data.userId)
    else this.selectedMembers.splice(this.selectedMembers.indexOf(data.userId), 1)

    console.log('ebtry', this.selectedMembers);
    console.log("ascd", eg)

    this.selectedCount = this.members.list.filter(
      (item) => item.selected === true
    ).length;
    this.emailIdlist = this.members.list.filter(
      (item) => item.selected === true
    );
    localStorage.setItem(
      AppConstant.localStorage.emailList,
      JSON.stringify(this.emailIdlist)
    );
  }
  handlePageChange(event) {
    this.page = event;
    this.member = this.members.list.slice(0, this.members.list.length < 10 ? this.members.list.length : (this.page - 1) * this.pageSize + this.pageSize)

  }
  // showAlert() : void {
  //   if (this.isVisible) { // if the alert is visible return
  //     return;
  //   }
  //   this.isVisible = true;
  //   setTimeout(()=> this.isVisible = false,2500); // hide the alert after 2.5s
  // }

  emailClick(member) {
    console.log('member', member);
    this.emailIdlist = [];
    this.emailIdlist = member;
    this.emailShow = true;
    localStorage.setItem(
      AppConstant.localStorage.emailList,
      JSON.stringify(this.emailIdlist.emailId).replace("[", '').replace("]", '')
    );

    this.adminService.setEmailList([this.emailIdlist.emailId]);

    // this.adminService.email = this.emailList
    // this.commonService.getApiauthorizationToken().subscribe((res) => {
    // this.token = 'Bearer' + ' ' + res;
    // if (this.token != null) {
    // this.url = APIs.sendBulkEmail;
    // const data = {
    //   UserId: member.userId
    // };
    // const header = {
    //   Authorization: this.token
    // }

    // this.commonService.getApiauthorizationToken().subscribe((res) => {
    //   this.token = 'Bearer' + ' ' + res;
    //   if (this.token != null) {
    //     this.url = APIs.sendBulkEmail;
    //     const data = {
    //       UserId: member.userId
    //     };
    //     const header = {
    //       Authorization: this.token
    //     }

    //     this.apiService.post(this.url, '', data, header).subscribe(
    //       (response: any) => {
    //         if (response.isValid) {
    //           if (this.isVisible) {
    //             return;
    //           }
    //           this.isVisible = true;
    //           setTimeout(() => this.isVisible = false, 2500)
    //         }
    //         // this.members=response;
    //         // let len =this.members.list.length;
    //       },
    //       err => console.log('error', err)
    //     );
    //   }
    // });

    this.router.navigate(['members/members-list/email']);
  }


  toggleShow() {
    this.show = !this.show;
  }
  removeItems(obj) {
    this.emailList = this.emailList.filter((item) => item !== obj);
    this.show = false;
    console.log('this.emil', this.emailList);
  }
  cancel() {
    this.router.navigate(['members/members-list']);
  }

  openMemberDetail(member) {
    localStorage.setItem(
      AppConstant.localStorage.memberDetail,
      JSON.stringify(member)
    );
    localStorage.setItem(AppConstant.localStorage.selectedMember, member.userId);
    this.router.navigate(['members/members-list/member-details']);
  }

  getName(name) {
    var str = name.toUpperCase()
    var matches = str.match(/\b(\w)/g); // ['J','S','O','N']
    if (matches?.length > 1) {
      var l = matches.slice(0, 2);
      this.acronym = l.join('');
    } else {
      this.acronym = matches.join(''); // JSON
    }
    return this.acronym
  }

  maskName(name: string): string {
    if (!name || !name.trim()) {
      return name;
    }

    return name
      .split(' ')
      .map(word =>
        word.length > 1
          ? word[0] + '*'.repeat(word.length - 1)
          : word
      )
      .join(' ');
  }

  maskPhone(phone: string): string {
    if (!phone) {
      return phone;
    }

    const digits = phone.replace(/\D/g, '');

    if (digits.length < 4) {
      return phone;
    }

    return (
      digits.substring(0, 2) +
      '*'.repeat(digits.length - 4) +
      digits.substring(digits.length - 2)
    );
  }

  maskEmail(email: string): string {
    if (!email) {
      return email;
    }

    const atIndex = email.indexOf('@');

    if (atIndex <= 2) {
      return '*'.repeat(atIndex) + email.substring(atIndex);
    }

    return (
      email.substring(0, 2) +
      '*'.repeat(atIndex - 2) +
      email.substring(atIndex)
    );
  }
}
